export default __webpack_public_path__ + "static/media/indexx-qr-logo.c18e8ce0.png";